import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { UpdateProviderProfileBody } from "@shared-kernel/application/ports/provider/provider-repository";

export const updateProviderProfile = createApiThunk<void, UpdateProviderProfileBody>(
  "providers/updateProviderProfile",
  async (body: UpdateProviderProfileBody, { extra: { providerRepository } }) => {
    return providerRepository!.updateProfile(body);
  },
);

export const resetUpdateProviderProfile = createAction("providers/resetUpdateProviderProfile");
